import request from '@/services/request'
import { getApiUrl, getEventApiUrl } from '@/utils/tool'

export function getCategory() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/category',
    method: 'post'
  })
}

export function getTypeMenuInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/menu-info',
    method: 'post'
  })
}

export function getHotGame(limit) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/hot',
    method: 'post',
    data: {
      limit: limit
    }
  })
}

export function getGames(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: !object.showLoading
    }
  })
}

export function getGameList(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/list',
    method: 'post',
    data: object
  })
}

export function getProviderNum() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/game/providerNum',
    method: 'post'
  })
}

export function getGameNum() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/game/num',
    method: 'post'
  })
}

export function getGameProvider(status) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/gameprovider',
    method: 'post',
    data: { status: status }
  })
}

export function gameLaunch(obj) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/launch',
    method: 'post',
    data: obj
  })
}

export function leaveAll() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/leave-all',
    method: 'post'
  })
}

export function gameBetRecord(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/bet-record-v2',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function rollLaunch() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/roll-launch',
    method: 'post'
  })
}

export function rollLeave() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/roll-leave',
    method: 'post'
  })
}

export function gameBalance() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/game-balance',
    method: 'post'
  })
}
export function oneGameBalance(obj) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/one-game-balance',
    method: 'post',
    data: obj
  })
}
export function withdrawalAll() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/withdrawal-all',
    method: 'post'
  })
}
export function withdrawal(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/withdrawal',
    method: 'post',
    data: object
  })
}
export function deposit(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/deposit',
    method: 'post',
    data: object
  })
}

export function gameLeave(game_id) {
  return request({
    baseURL: getApiUrl(),
    url: '/game/leave',
    method: 'post',
    data: { game_id: game_id }
  })
}

export function getShowOffGameBets() {
  return request({
    baseURL: getApiUrl(),
    url: '/game/get-show-off-game-bets',
    method: 'post',
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}
